import { render, staticRenderFns } from "./ReminderAiModeTab.vue?vue&type=template&id=2a8a02e3&scoped=true"
import script from "./ReminderAiModeTab.vue?vue&type=script&lang=js"
export * from "./ReminderAiModeTab.vue?vue&type=script&lang=js"
import style0 from "./ReminderAiModeTab.vue?vue&type=style&index=0&id=2a8a02e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a02e3",
  null
  
)

export default component.exports